import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateMessage'
})
export class DateMessagePipe implements PipeTransform {

  transform(value: any): any {
    const date = new Date(value);
    const today = new Date();
    const monthNames = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'];
    const day = this.zeroTransform(date.getDate());
    const hours = this.zeroTransform(date.getHours());
    const minutes = this.zeroTransform(date.getMinutes());
    if (date.getDate() !== today.getDate()) {
      return `${day} ${monthNames[date.getMonth()]} ${date.getFullYear()} ${hours}:${minutes}`
    } else {
      return `${hours}:${minutes}`
    }
  }

  zeroTransform(n: number) {
    return n < 10 ? `0${n}` : n;
  }
}
